<template>
  <div class="handles-list">
    <div class="handles-list-close" @click="close">

    </div>
    <vue-custom-scrollbar  class="handles-list-container" :style="{'height': height + 'px'}">
      <div class="handles-list-container-item" @click="chooselink(handle.handle,handle)" :class="handle.event_type" v-for="handle in handles">
        <div class="handles-list-container-item-picture" :style="{'background-image':'url('+handle.photo_small+')'}">

        </div>
        <div class="handles-list-container-item-names">
          @{{handle.handle}} {{handle.headline}}
        </div>
      </div>
      <infinite-loading
          ref="infiniteLoadingHandles"
          @infinite="getHandles"
          spinner="bubbles"
          direction="bottom">
        <span slot="no-results" v-if="false">Handles not exists</span>
        <span slot="no-more" v-if="false">No more handles</span>
      </infinite-loading>
    </vue-custom-scrollbar>
  </div>
</template>

<script>
// custom scrollbar
import vueCustomScrollbar from 'vue-custom-scrollbar'
import "vue-custom-scrollbar/dist/vueScrollbar.css"
import {mapGetters, mapActions} from 'vuex'
import chatModule from "../../../chat/module/store/type";
import VueCustomScrollbar from "vue-custom-scrollbar/src/vue-scrollbar.vue";

export default {
    components: {VueCustomScrollbar},
    props: ['text', 'except'],

    mixins: [
      require('@general/lib/mixin').default
    ],
    computed: {
        ...mapGetters({
        }),
    },
    methods: {
        ...mapActions({
          getHandlesList: 'getHandlesList'
        }),
        chooselink(link,info){
          this.$emit('choose-handle',link,info)
        },
        close(){
          this.$emit('close-handles-list')
        },
        async getHandles(infiniteScroll){
            let new_handles = await this.getHandlesList({except:this.except,handle:this.text,page:this.page,limit:this.limit});
            this.handles.push(...new_handles);
            if(!this.handles.length){
              this.close();
            }
            if(this.handles.length < 10){
              this.height = this.handles.length * 35 > 200 ? 200 : this.handles.length * 35;
            }else{
              this.height = 200;
            }
            this.page++;
            infiniteScroll.loaded()
            if(new_handles.length < this.limit){
              infiniteScroll.complete()
            }
        }
    },

  watch: {
      text: function (text){
          if(text){
            if (this.$refs.infiniteLoadingHandles) {
              this.page = 1;
              this.handles =  [];
              this.$refs.infiniteLoadingHandles.stateChanger.reset();
            }
          }
      }
  },
  data() {
    return {
      handles: [],
      page: 1,
      limit: 10,
      height: 200
    }
  }
}
</script>
